export const layerNames = {
  BackgroundShape: 'BackgroundShape',
  BackgroundTexture: 'BackgroundTexture',
  Product: 'Product',
  AIShadow: 'AIShadow',
}
